common.View.create('canvas.blocks.modules.blog.Block', {

    onDOMLoad() {

    },

});
